"use client";
import React, { Suspense } from "react";
import styles from "./Header.module.css";
import { clsx } from "@frend-digital/ui";
import { MobileMenu } from "./MobileMenu";
import { MobileMenuContent } from "./MobileMenuContent";
import { Search } from "../Search";
import { usePathname } from "@/i18n/routing";
import { VikingLogo } from "@/components/icons/Logo";
import { AccountButton } from "./AccountIcon";
import { CartModalTrigger } from "@/features/cart/CartModal";
import { CartAmount } from "@/features/cart";
import type { BlokNavigation } from "@/storyblok";
import type { RPC } from "@/data/routes/router";
import { Chevron } from "@/components/icons/Chevron";
import { Translate } from "@/components/Translate";
import { Link } from "@/i18n/Link";
import type { StoryblokRichtext } from "@/storyblok-base";

export const MobileHeader = ({
	preview,
	content,
	signupTerms,
}: {
	preview: boolean;
	content: BlokNavigation;
	signupTerms?: StoryblokRichtext;
}) => {
	const pathname = usePathname();

	const isCheckout = pathname.includes("checkout") && !pathname.includes("summary");
	return (
		<div className={clsx(styles.mobileHeader)}>
			{isCheckout ? (
				<Link href="/" className={styles.backButton}>
					<Chevron style={{ transform: "rotate(90deg)" }} />
					<span>
						<Translate>Back</Translate>
					</span>
				</Link>
			) : (
				<div className={styles.mobileActions}>
					<Suspense>
						<MobileMenu>
							<MobileMenuContent preview={preview} content={content} signupTerms={signupTerms} />
						</MobileMenu>
					</Suspense>
					<Search />
				</div>
			)}
			<Link href="/">
				<VikingLogo className={styles.logo} height="20px" />
			</Link>
			{!isCheckout && (
				<nav className={clsx(styles.mobileActions, styles.last)}>
					<AccountButton />
					<CartModalTrigger asChild>
						<CartAmount />
					</CartModalTrigger>
				</nav>
			)}
		</div>
	);
};
